module.exports = __webpack_public_path__ + "assets/142a940a04ecabb45f2d27e32fe1cec5.mp3";